import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Separator } from "../ui/separator";
import { ValidatedInput, ValidatedTextarea, FormGroup } from "../ui/validated-input";
import { MapPin, Phone, Mail, Globe } from "lucide-react";

const CompanyAddressCard = ({ getFieldProps, isEditing, isValidating, phonePlaceholder }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader className="pb-5">
        <CardTitle className="flex items-center gap-2.5 text-sm font-semibold" style={{ color: "var(--lm-ink)" }}>
          <div className="p-1.5 rounded-md" style={{ backgroundColor: "rgba(39,166,68,0.10)" }}>
            <MapPin className="h-4 w-4" style={{ color: "#27a644" }} />
          </div>
          <span>{t("companyConfig.sections.address")}</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <FormGroup>
          <ValidatedTextarea
            {...getFieldProps("address_line1")}
            id="address_line1"
            label={t("companyConfig.labels.address")}
            placeholder={t("companyConfig.placeholders.address")}
            disabled={!isEditing}
            rows={3}
            isValidating={isValidating}
            className="focus:ring-primary focus:border-primary"
          />

          <div className="grid grid-cols-2 gap-4">
            <ValidatedInput
              {...getFieldProps("city")}
              id="city"
              label={t("companyConfig.labels.city")}
              placeholder={t("companyConfig.placeholders.city")}
              disabled={!isEditing}
              isValidating={isValidating}
              className="focus:ring-primary focus:border-primary"
            />
            <ValidatedInput
              {...getFieldProps("postal_code")}
              id="postal_code"
              label={t("companyConfig.labels.postalCode")}
              placeholder={t("companyConfig.placeholders.postalCode")}
              disabled={!isEditing}
              isValidating={isValidating}
              className="focus:ring-primary focus:border-primary"
            />
          </div>

          <ValidatedInput
            {...getFieldProps("country")}
            id="country"
            label={t("companyConfig.labels.country")}
            placeholder={t("companyConfig.placeholders.country")}
            disabled={!isEditing}
            isValidating={isValidating}
            className="focus:ring-primary focus:border-primary"
          />

          <Separator />

          <ValidatedInput
            {...getFieldProps("phone")}
            id="phone"
            label={t("companyConfig.labels.phone")}
            placeholder={phonePlaceholder || t("companyConfig.placeholders.phone")}
            disabled={!isEditing}
            icon={Phone}
            isValidating={isValidating}
            className="focus:ring-primary focus:border-primary"
          />

          <ValidatedInput
            {...getFieldProps("email")}
            id="email"
            label={t("companyConfig.labels.email")}
            type="email"
            placeholder={t("companyConfig.placeholders.email")}
            disabled={!isEditing}
            icon={Mail}
            helpText={t("companyConfig.help.email")}
            isValidating={isValidating}
            className="focus:ring-primary focus:border-primary"
          />

          <ValidatedInput
            {...getFieldProps("website")}
            id="website"
            label={t("companyConfig.labels.website")}
            type="url"
            placeholder={t("companyConfig.placeholders.website")}
            disabled={!isEditing}
            icon={Globe}
            helpText={t("companyConfig.help.website")}
            isValidating={isValidating}
            className="focus:ring-primary focus:border-primary"
          />

          <ValidatedInput
            {...getFieldProps("vat_number")}
            id="vat_number"
            label={t("companyConfig.labels.vatNumber")}
            placeholder={t("companyConfig.placeholders.vatNumber")}
            disabled={!isEditing}
            isValidating={isValidating}
            className="focus:ring-primary focus:border-primary"
          />
        </FormGroup>
      </CardContent>
    </Card>
  );
};

export default CompanyAddressCard;
